import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45cb1cd9")

_pushScopeId("data-v-45cb1cd9")
const _hoisted_1 = { class: "dialog__content" }
const _hoisted_2 = { class: "dialog__list" }
const _hoisted_3 = { class: "dialog__item" }
const _hoisted_4 = { class: "dialog__item" }
const _hoisted_5 = { class: "dialog__item" }
const _hoisted_6 = { class: "dialog__item" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheDateFilter = _resolveComponent("TheDateFilter")
  const _component_TheFieldFilter = _resolveComponent("TheFieldFilter")
  const _component_TheTeamFilter = _resolveComponent("TheTeamFilter")
  const _component_TheDivisionFilter = _resolveComponent("TheDivisionFilter")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withId(() => [
      (_ctx.scheduleFilterDialogVisible)
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            showHeader: true,
            headerTitle: "Filtrer le calendrier",
            tabindex: "0",
            onClose: _ctx.closeDialog,
            onKeydown: _withKeys(_ctx.closeDialog, ["esc"]),
            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
          }, {
            body: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_TheDateFilter, { filterSetName: _ctx.filterSetName }, null, 8, ["filterSetName"])
                  ]),
                  _createVNode("div", _hoisted_4, [
                    _createVNode(_component_TheFieldFilter, {
                      collapsed: _ctx.collapsed[0],
                      filterSetName: _ctx.filterSetName,
                      onFltCollapse: _cache[1] || (_cache[1] = ($event: any) => (_ctx.collapseOthers(0)))
                    }, null, 8, ["collapsed", "filterSetName"])
                  ]),
                  _createVNode("div", _hoisted_5, [
                    _createVNode(_component_TheTeamFilter, {
                      collapsed: _ctx.collapsed[1],
                      filterSetName: _ctx.filterSetName,
                      onFltCollapse: _cache[2] || (_cache[2] = ($event: any) => (_ctx.collapseOthers(1)))
                    }, null, 8, ["collapsed", "filterSetName"])
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _createVNode(_component_TheDivisionFilter, {
                      collapsed: _ctx.collapsed[2],
                      filterSetName: _ctx.filterSetName,
                      onFltCollapse: _cache[3] || (_cache[3] = ($event: any) => (_ctx.collapseOthers(2)))
                    }, null, 8, ["collapsed", "filterSetName"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClose", "onKeydown"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})